import React, { useEffect, useMemo, useState } from "react";
import { Table } from "ui";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { ColumnDef } from "@tanstack/react-table";
import { EyeFill } from "react-bootstrap-icons";
import { wage } from "../type";
import { processCodeMessage } from "../../checkouts-list/utils";
import { useAppDispatch, useAppSelector } from "../../../store";
import { setModalVisibility } from "../../layouts/landing-layout/slice";
import { WAGES_TABLE_COLUMNS } from "../constant";
import { CheckoutWithWageId } from "./checkout-with-wage-id";

interface wagesTableProp {
  wages?: wage[];
  error?: string | null;
  isLoading?: boolean;
  page: number;
  pageSize: number;
}
export const WagesTable: React.FC<wagesTableProp> = ({
  wages,
  error,
  isLoading = false,
  page,
  pageSize,
}) => {
  const [selectedWage, setSelectedWage] = useState<number>();
  const dispatch = useAppDispatch();
  const modalVisibility = useAppSelector((state) => state.app.modalVisibility);
  const data = useMemo(() => {
    return (
      wages?.map((item, i) => {
        return {
          $: i + 1 + pageSize * (page - 1),
          date: item.dateFa || "-",
          settlementAmount: item.settlementAmount.toLocaleString(),
          wage: item.wageAmount,
          acceptorCode: item.acceptorCode,
          isProcess: !item.isProcess
            ? "عدم تصویه"
            : processCodeMessage(item.processCode),
          more: item.id,
        };
      }) || []
    );
  }, [page, pageSize, wages]);
  const wagesTable: ColumnDef<typeof data>[] = [
    ...WAGES_TABLE_COLUMNS,
    {
      accessorKey: "more",
      header: "جزئیات ",
      cell: (cell) => {
        return (
          <button
            className="button--striped"
            onClick={() => {
              setSelectedWage(cell.getValue() as number);
              dispatch(setModalVisibility(true));
            }}
          >
            <EyeFill />
          </button>
        );
      },
    },
  ];

  if (!!error || !data) {
    return <div className="text-danger">{error}</div>;
  } else {
    return (
      <>
        <Table
          isLoading={isLoading}
          columns={wagesTable}
          data={data}
          getRowCanExpand={() => true}
        />

        <Modal
          centered
          size="xl"
          dialogClassName="modal-w-70"
          show={modalVisibility}
          onHide={() => {
            setSelectedWage(undefined);
            dispatch(setModalVisibility(false));
          }}
        >
          <ModalHeader closeButton>
            <h1 className="p-2"> جزئیات تسویه شاپرکی</h1>
          </ModalHeader>
          <ModalBody>
            {selectedWage && <CheckoutWithWageId id={selectedWage} />}
          </ModalBody>
        </Modal>
      </>
    );
  }
};
